export const placeholderChars = {
  whitespace: '\u2000',
  underscore: '_'
};

export const textMaskProps = [
  'placeholder',
  'placeholderChar',
  'pipe',
  'keepCharPositions',
  'mask',
  'guide'
];

export const alphabetic = /[A-Z]/i;
export const digit = /\d/;
